import { axiosInstance } from '../config/axios';
import { isNative, platform } from '../lib/native';

// Deprecated localStorage-based functions (kept for backward compatibility during migration)
export const MEMBERSHIP_STORAGE_KEY = 'byard-membership';

export const getMembershipLocal = () => {
  if (typeof window === 'undefined') return null;
  const stored = localStorage.getItem(MEMBERSHIP_STORAGE_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch {
    return null;
  }
};

export const clearMembershipLocal = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(MEMBERSHIP_STORAGE_KEY);
};

// New backend-based functions
export const getMembership = async () => {
  try {
    const response = await axiosInstance.get('/memberships/me');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch membership:', error);
    return null;
  }
};

export const getMembershipPlans = async () => {
  try {
    const response = await axiosInstance.get('/memberships/plans');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch membership plans:', error);
    return [];
  }
};

export const purchaseMembership = async (planId, razorpayOrderId, razorpayPaymentId) => {
  try {
    const response = await axiosInstance.post('/memberships/purchase', {
      plan_id: planId,
      razorpay_order_id: razorpayOrderId,
      razorpay_payment_id: razorpayPaymentId,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to purchase membership:', error);
    throw error;
  }
};

export const redeemCredits = async (amount, referenceType, referenceId, description = null) => {
  try {
    const response = await axiosInstance.post('/memberships/use-credits', {
      amount,
      reference_type: referenceType,
      reference_id: referenceId,
      description,
    });
    return response.data;
  } catch (error) {
    console.error('Failed to use credits:', error);
    throw error;
  }
};

export const getCreditTransactions = async () => {
  try {
    const response = await axiosInstance.get('/memberships/transactions');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch transactions:', error);
    return [];
  }
};

// Memberships are bought with Razorpay and load wallet credits. In the iOS app
// Apple may treat that as digital currency sold outside In-App Purchase
// (guideline 3.1.1), so iOS hides every way to buy or be pointed at buying one.
// Existing members still see and spend their credits there. Web and Android
// are unaffected.
export const canPurchaseMembership = () => !(isNative() && platform() === 'ios');

export const isMembershipActive = (membership) => {
  if (!membership || membership.status !== 'active') return false;
  return new Date(membership.expires_at) > new Date();
};
